import { ReactNode, useContext, useEffect } from 'react'

import { PortalContext } from 'core-components/library/popup'

import { PopupContext } from './Context'

interface IPopupController {
  children: ReactNode
  modal: boolean
}
const closeCallbacks: Array<() => void> = []
let MODAL_POPUP_COUNT = 0

export const PopupController = ({ children, modal }: IPopupController) => {
  const { globalEventsNode } = useContext(PortalContext)
  const findIndex = (fn: () => void) => closeCallbacks.findIndex((value) => value === fn)

  useEffect(() => {
    const keyHandler: EventListenerOrEventListenerObject = (e: Event) => {
      if (closeCallbacks.length > 0) {
        if ((e as KeyboardEvent).key === 'Escape') {
          closeCallbacks[closeCallbacks.length - 1]()
          e.stopImmediatePropagation()
        }
      }
    }
    globalEventsNode.addEventListener('keydown', keyHandler, true)
    return () => {
      globalEventsNode.removeEventListener('keydown', keyHandler, true)
    }
  }, [globalEventsNode])

  useEffect(() => {
    const updateClassOnDocument = (hasModal: boolean) => {
      if (hasModal) {
        document.documentElement.style.overflow = 'hidden'
      } else {
        document.documentElement.style.overflow = ''
      }
    }

    if (modal) {
      MODAL_POPUP_COUNT++
    }
    updateClassOnDocument(MODAL_POPUP_COUNT > 0)
    return () => {
      if (modal) {
        MODAL_POPUP_COUNT--
      }
      updateClassOnDocument(MODAL_POPUP_COUNT > 0)
    }
  }, [modal])

  return (
    <PopupContext.Provider
      value={{
        register: (closeFn) => {
          const index = findIndex(closeFn)
          if (index === -1) {
            closeCallbacks.push(closeFn)
          }
        },
        unregister: (closeFn) => {
          const index = findIndex(closeFn)
          if (index > -1) {
            closeCallbacks.splice(index, 1)
          }
        },
      }}
    >
      {children}
    </PopupContext.Provider>
  )
}
